import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

/**
 * This is meant to get config settings into the 'environment' object in order for the providers to use them
 * if you use this main.ts, note that bootstrapModule is inside of runApp
 * this is a scripting file so call it at the end
 * */
const runApp = async () => {
  console.log(document.getElementsByTagName('base'));
  const populateEnv = () => new Promise(async (resolve) => {
    await fetch(
      `${document.getElementsByTagName('base')[0].href}api/configuration/getauthconfig`,
      { method: 'GET' })
      .then(res => res.json())
      .then((json) => {
        // confirm config variables if you use this
        environment.auth = {
          ...environment.auth,
          clientId: json.clientId,
          authority: json.authority,
          apiScope: json.apiScope,
        };
      });
    resolve(true);
  });

  populateEnv().then(() => {
    platformBrowser(providers).bootstrapModule(AppModule)
      .catch(err => console.log(err));
  });
};

// MUST CALL FOR ANGULAR TO RUN
runApp();
